import { Component, OnInit, Inject  } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'pm-provider-list-modal',
  templateUrl: './provider-list-modal.component.html',
  styleUrls: ['./provider-list-modal.component.css']
})
export class ProviderListModalComponent {
  providers: any[] = [];
  filteredProviders: any[] = [];
  searchText: string = '';

  constructor(
    public dialogRef: MatDialogRef<ProviderListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.providers = data.providers || [];
    this.filteredProviders = [...this.providers];
  }

  onSearch(): void {
    const text = (this.searchText || '').toLowerCase().trim();

    if (!text) {
      this.filteredProviders = [...this.providers];
      return;
    }

    this.filteredProviders = this.providers.filter((provider) => {
      const fullName = `${provider.firstName || ''} ${provider.lastName || ''}`.toLowerCase();
      const address = `${provider.addressLine1 || ''} ${provider.addressLine2 || ''} ${provider.city || ''} ${provider.state || ''} ${provider.zipCode || ''}`.toLowerCase();
      return (
        fullName.includes(text) ||
        (provider.npi || '').toLowerCase().includes(text) ||
        (provider.taxId || '').toLowerCase().includes(text) ||
        (provider.license || '').toLowerCase().includes(text) ||
          address.includes(text)
      );
    });
  }

  selectProvider(provider: any): void {
    this.dialogRef.close(provider);
  }

  close(): void {
    this.dialogRef.close();
  }
}
